export default [{
  name: 'login',
  path: '/login',
  component: () => import('./Login.vue')
}]



// WEBPACK FOOTER //
// ./src/router/login/index.js